function Diamond() {
  return (
    <svg viewBox="0 0 12 12" className="h-3 w-3 text-gold" aria-hidden="true">
      <path d="M6 0L7.6 4.4 12 6 7.6 7.6 6 12 4.4 7.6 0 6l4.4-1.6L6 0Z" fill="currentColor" />
    </svg>
  );
}

const ITEMS = [
  "Sat Sri Akal",
  "Handgefertigter Schmuck",
  "Phulkari & Suiten",
  "Tradition & Liebe",
];

function Row({ hidden }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-serif text-2xl font-light italic text-gold md:text-3xl">
            {item}
          </span>
          <Diamond />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-gold/15 bg-wine2 py-6"
      data-testid="marquee"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
